import { render } from "./DragonsthreeView.vue?vue&type=template&id=6b079577"
import script from "./DragonsthreeView.vue?vue&type=script&lang=js"
export * from "./DragonsthreeView.vue?vue&type=script&lang=js"

import "./DragonsthreeView.vue?vue&type=style&index=0&id=6b079577&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__